import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'irembogov-right-flyout-sidebar',
  templateUrl: './irembo-right-flyout-sidebar.component.html',
  styleUrls: ['./irembo-right-flyout-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IremboRightFlyoutSidebarWrapperComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() paneOpen = false;
  @Output() OnPaneToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  closePane() {
    this.paneOpen = false;
    this.OnPaneToggle.emit(this.paneOpen);
  }
}
